<template>
  <div class="d-flex flex-column" v-if="cart && cart.length">
    <b-alert
        v-if="showAlert"
        show dismissible
        class="alert-height"
        variant="success"
      ><div class="text-nowrap">Order updated successfully!</div>
    </b-alert>
    <div class="cart-order-summary d-flex justify-content-between align-items-center">
      <span class="heading">Order Summary</span>
      <svg class="heading-icon" xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" @click.stop="$emit('close')">
        <circle cx="22" cy="22" r="22" fill="#FAFAFA"/>
        <path d="M31 31L13 13L31 31ZM31 13L13 31L31 13Z" fill="#FAFAFA"/>
        <path d="M31 31L13 13M31 13L13 31" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <div class="w-100 cart-align align-self-start">
      <table class="w-100">
        <tr class="border-bottom" v-for="(item, index) in cart" :key="'cart-item-' + index.toString()">
          <td class="px-2">
            <img class="cart-product-image" :src="getImageUrl(item)" @error="setAltImg($event, item)" alt="" />
          </td>
          <td class="cart-product-name-cell w-100">
            <div>
              <div class="d-flex justify-content-between">
                <span class="cart-product-name mr-2" v-html="item.campaign_product.name"></span>
                <div type="button" v-b-tooltip.hover title="Remove product from cart">
                  <font-awesome-icon class="mt-1" :style="{ color: 'rgb(255 63 63)' }"
                                     :icon="['fas', 'trash-alt']"
                                     @click="updateQuantity(index, 0, false)"
                  >
                  </font-awesome-icon>
                </div>
              </div>
              <div v-if="item.variant" class="product-variants">
                {{getItemVariants(item)}}
              </div>
              <div class="cart-product-name-text">Qty: {{item.quantity}}</div>
            </div>
            <div class="quantity-toggle mt-2 justify-content-between">
              <div class="cart-quantity-wrapper">
                <button :disabled="item.quantity === 1 || item.campaign_product.max_quantity === 1" class="cart-quantity-button" @click="updateQuantity(index, item.quantity-1, false)">&mdash;</button>
                <input class="cart-quantity-input" type="number" oninput="this.value=parseInt(this.value)" step="1" min="1"
                       :max="item.campaign_product.max_quantity || 10"
                       :value="item.quantity" @change="updateQuantity(index, $event)"
                       :disabled="item.campaign_product.max_quantity === 1"
                />
                <button :disabled="item.quantity >= item.campaign_product.max_quantity" class="cart-quantity-button" @click="updateQuantity(index, item.quantity+1, false)">&#xff0b;</button>
              </div>
              <div class="cart-product-price">{{getPrice(item) | currency(item.campaign_product.currency)}}</div>
            </div>
            <p v-if="item.quantity >= item.campaign_product.max_quantity" class="max-quantity">
              <sup>*</sup>Maximum order limit of {{item.campaign_product.max_quantity}}
            </p>
          </td>
        </tr>
      </table>
    </div>
    <div class="cart-btn-wrapper">
      <b-button @click="$emit('close')" block class="cart-btn continue-btn stroke-2x">Continue Shopping</b-button>
      <b-button @click="continueToCheckout" class="mt-2 cart-btn checkout-btn">
        Checkout
        <span class="float-right pr-2">
          <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
        </span>
      </b-button>
    </div>
    <CheckoutCustomerConfirmation  @close="closePopUp"  v-on:verified="customerVerified" @verificationFailed="customerVerificationFailed"
                                  v-if="showVerificationPopup"></CheckoutCustomerConfirmation>
  </div>
  <div v-else>
    Nothing in cart
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import {mapState, mapGetters} from 'vuex'
import {
  calculatePrice,
  getItemVariants, setFallbackImageUrl, getCampaignProductImageUrl
} from '@/utils'
const CheckoutCustomerConfirmation = () => import('../components/CheckoutCustomerConfirmation')

export default {
  name: 'Cart',
  components: {CheckoutCustomerConfirmation},
  data: function() {
    return {
      showVerificationPopup: false,
      showAlert: false
    }
  },
  computed: {
    ...mapState(['cart', 'session']),
    ...mapGetters(['isSessionUserKnown']),
    totalPrice: function() {
      let total = 0

      if (this.cart && this.cart.length) {
        this.cart.forEach(item => {
          total += calculatePrice(item, this.session)
        })
      }

      return total.toFixed(2)
    }
  },
  methods: {
    debounceCartUpdate: debounce(function(e) {
      this.$store.dispatch('set_cart', this.cart)
    }, 500),
    closePopUp: function() {
      this.showVerificationPopup = false
    },
    getPrice: function(item) {
      let price = calculatePrice(item, this.session)
      if (price !== null && !isNaN(price) && price !== undefined) {
        return price.toFixed(2)
      }
      return '0'
    },
    getItemVariants: function(item) {
      return getItemVariants(item)
    },
    getImageUrl: function(item) {
      return getCampaignProductImageUrl(item.campaign_product, 'small')
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item.campaign_product, 'small')
    },
    updateQuantity: function(index, event, isEvent = true) {
      let updatedCart = this.cart.slice()
      let quantity = 0
      if (isEvent) {
        if (event.currentTarget.value && event.currentTarget.value.length > 0) {
          quantity = parseInt(event.currentTarget.value)
        }
      } else {
        quantity = event
      }
      if (quantity >= 0) {
        if (quantity <= updatedCart[index].campaign_product['max_quantity']) {
          updatedCart[index].quantity = parseInt(quantity)
        } else {
          updatedCart[index].quantity = updatedCart[index].campaign_product['max_quantity']
        }
      } else {
        updatedCart[index].quantity = 0
      }

      this.debounceCartUpdate()
    },
    continueToCheckout: function() {
      if (this.isSessionUserKnown) {
        this.customerVerified()
      } else {
        this.showVerificationPopup = true
      }
      if (window.innerWidth > 575) {
        this.$emit('close')
      }
    },
    customerVerified: function() {
      this.showVerificationPopup = false
      this.$store.commit('clear_step_stack')
      this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
    },
    customerVerificationFailed: function(message) {
      this.$store.commit('error', message)
    }
  }
}
</script>

<style scoped lang="less">
  .cart-btn-wrapper {
    .continue-btn {
      background-color: white !important;
      color: var(--theme_color) !important;
      border-color: var(--theme_color) !important;
    }
    .checkout-btn {
      color: #ffffff !important;
      background-color: var(--theme_color) !important;
      border-color: var(--theme_color) !important;
    }
  }

  @media only screen and (max-width: 575px){
    .cart-btn-wrapper {
      position: fixed;
      bottom: 0;
      left: unset;
      padding: 1.5rem;
      width: 335px;
      max-width: 100%;
      background-color: white;
      overflow: hidden;
      border-left: 1px solid #dee2e6;
      box-shadow: 0 10px 20px 0 #00000026;
    }
  }
</style>
